import { addWorkspace } from "api/services/workspace-service";
import useApiCall from "hooks/useApiCall";

export const useAddWorkspace = () => {
    const { callAPI, loading } = useApiCall(addWorkspace, 'addWorkspace.success', 'addWorkspace.error');

    return { addWorkspace: callAPI, addingWorkspace: loading };
}